import { withTheme as withWithMaterialUiTheme } from '@material-ui/core';

/**
 * Wrap the component in styled component shared dependencies
 */
function withOpStyles(Component: any) {
    return withWithMaterialUiTheme(Component);
}

export default withOpStyles;